import React from 'react';

const Security = ({viewUser,load}) => {

  return (
    <div className="security-comp">
      security-comp
    </div>
  );

};

export default Security;